const strings = {
  MANDATORY_FIELD: 'Fältet är oblikatoriskt',
  LAUNDRY_CREATED: {
    S: 'Tvättstugan har skapats',
    M: 'Tvättmaskinen har skapats'
  },
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.',
  NEW_LAUNDRY: {
    S: 'Skapa en tvättstuga',
    M: 'Skapa en tvättmaskin'
  },
  NEW_LAUNDRY_INFORMATION: {
    S: 'Välj ett namn för din nya tvättstuga.',
    M: 'Välj ett namn för din nya tvättmaskin.'
  }
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/NewLaundryModal/strings.js